// This organizational structure will work okay so long as events exist in a small limited number

const CustomEvents = {
  'sbevents:site-page-view': {
    category: 'site',
    name: 'site-page-view',
  },
  'sbevents:location-search': {
    category: 'location',
    name: 'location-search',
  },
  'sbevents:location-infowindow': {
    category: 'location',
    name: 'location-infowindow',
  },
  'sbevents:map-user-interact': {
    category: 'map',
    name: 'map-user-interact',
  },
  'sbevents:coupon-redeem': {
    category: 'coupon',
    name: 'coupon-redeem',
  },
  'sbevents:coupon-email': {
    category: 'coupon',
    name: 'coupon-email',
  },
  'sbevents:coupon-sms': {
    category: 'coupon',
    name: 'coupon-sms',
  },
  // 'sbevents:coupon-print': {
  //   category: 'coupon',
  //   name: 'coupon-print',
  // },
  'sbevents:coupon-share': {
    category: 'coupon',
    name: 'coupon-share',
  },
  'sbevents:coupon-share-facebook': {
    category: 'coupon',
    name: 'coupon-share-facebook',
  },
  'sbevents:coupon-share-twitter': {
    category: 'coupon',
    name: 'coupon-share-twitter',
  },
  'sbevents:scheduler-load': {
    category: 'scheduler',
    name: 'scheduler-load',
  },
  'sbevents:scheduler-schedule': {
    category: 'scheduler',
    name: 'scheduler-schedule',
  }
}

// https://css-tricks.com/snippets/css/style-links-depending-on-destination/
// https://www.w3schools.com/cssref/css_selectors.asp
// Only the first matching element in the array is returned as the matching analytic event
// other matches are ignored

const AnalyticsEvents = [
  {
    category: 'custom',
    modes: 'all',
    name: 'custom-link',
    event: 'click',
    extracts: {
      elementAttribute: {
        property: 'href',
      },
    },
    selector: 'a[data-sb-custom-event]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-file',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    // Do we want more file types?
    // Download: href notes
    // <a download=""> is only valid post edge 14
    // <a href="" download> edge 13
    // <a href="/file.fileType" still compatible with ie10 and back
    // $ checks only for file type and speeds processing considerably.
    selector: 'a[download], a[href$=".dmg"], a[href$=".doc"], a[href$=".docx"], a[href$=".pdf"], a[href$=".ppt"], a[href$=".pptx"], a[href$=".zip"], a[href$=".xls"], a[href$=".xlsx"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-sms',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[href^="sms:"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-call',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[href^="tel:"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-email',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[href^="mailto:"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-facebook',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[href*="www.facebook.com"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-instagram',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[href*="instagram.com"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-linkedin',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[href*="linkedin.com"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-twitter',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[href*="twitter.com"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-yelp',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[href*="yelp.com"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-youtube',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[href*="youtube.com"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'map',
    modes: 'all',
    name: 'map-get-directions',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[data-sb-event="map-get-directions"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-get-directions',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[href*="/map/dir/"],a[data-sb-event="link-get-directions"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'site',
    name: 'link-locationpage',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector: 'a[data-sb-event="link-locationpage"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'share',
    modes: 'site',
    name: 'share-homepage',
    event: 'click',
    selector: 'a[data-sb-event="share-homepage"][href]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'site',
    name: 'link-homepage',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    selector:
    // be careful of auto injected '/'
    'a[data-sb-event="link-homepage"]',
    shouldTrack: function(element, selector) {
      return true;
    },
  },
  {
    category: 'coupon',
    modes: 'site',
    name: 'coupon-print',
    event: 'click',
    selector: 'a[data-sb-event="coupon-print"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'link',
    modes: 'all',
    name: 'link-outgoing',
    event: 'click',
    extracts: {
      elementAttribute: {
          property: 'href',
      },
    },
    // link-outgoing is difficult to define because it is defined mostly by negatory conditional logical
    // "//" external non protocol is the one guaranteed affirmative match
    // Proxy does not use homepage_url and therefore requires a different selector
    selector: 'a[href^="//"], a:not([href^="/"]):not([href^="#"]):not([href^="javascript"]):not([href=""])',
    shouldTrack: function(element, selector) {
      // html selectors are poor at complex logic therefore javascript is used
      // element.href.substring(0, 5) !== window.sb.siteInfo.homepage_url.substring(0, 5) is basic way to sniff out protocol mismatches
      if (element.href.includes(window.location.origin)
        || !element.href
        || element.href.substring(0, 5) !== window.location.origin.substring(0, 5)) {
        return false;
      }
      return true;
    },
  },
  // The specifics of this selector have not been established as of 2019
  // {
  //   category: 'video',
  //   name: 'video-play',
  //   event: 'click',
  //   tagNames: ['DIV', 'SPAN'],
  //   shouldTrack: function(event, selector) {
  //       
  //       if (!this.tagNames.includes(e.target.tagName)) return false;
        // if (e.target.getAttribute('data-sb-event') !== 'video-play') return false;
  //       return (this.selector === selector);
  //   },
  // },
  {
    category: 'site',
    modes: 'site',
    name: 'site-print',
    event: 'click',
    selector: 'div[data-sb-event="site-print"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'social',
    modes: 'site',
    name: 'site-share',
    event: 'click',
    selector: 'div[data-sb-event="site-share"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'site',
    modes: 'site',
    name: 'site-bookmark',
    event: 'click',
    selector: 'div[data-sb-event="site-bookmark"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'site',
    modes: 'site',
    name: 'share-modal',
    event: 'click',
    selector: 'div[data-sb-event="share-modal"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'share',
    modes: 'site',
    name: 'share-instagram',
    event: 'click',
    selector: 'div[data-sb-event="share-instagram"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'share',
    modes: 'site',
    name: 'share-linkedin',
    event: 'click',
    selector: 'div[data-sb-event="share-linkedin"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'share',
    modes: 'site',
    name: 'share-facebook',
    event: 'click',
    selector: 'div[data-sb-event="share-facebook"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'share',
    modes: 'site',
    name: 'share-twitter',
    event: 'click',
    selector: 'div[data-sb-event="share-twitter"]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'custom',
    modes: 'all',
    name: 'custom-form-submit',
    event: 'submit',
    selector: 'form[data-sb-custom-event]',
    shouldTrack: function() {
      return true;
    },
  },
  {
    category: 'form',
    modes: 'all',
    name: 'form-submit',
    event: 'submit',
    extracts: {
      serialize: true,
      serializeForm: true
    },
    selector: 'form',
    shouldTrack: function() {
      // When developing or testing forms this location seems to be the best place to intercept the event
      // e.preventDefault();
      return true;
    }
  }
]

export { AnalyticsEvents, CustomEvents }